import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { getSideMenuStatus } from 'src/app/angular-wallet-base/store/appSettings';
import { AppState } from 'src/app/angular-wallet-base/store/appState';

@Component({
  selector: 'app-vault-promo-modal',
  templateUrl: './vault.promo.modal.html',
  styleUrls: ['./vault.promo.modal.scss']
})
export class VaultPromoModalComponent implements OnInit {
  @Input() newMember: string;

  constructor(
    private modal: ModalController,
    protected store: Store<AppState>,
  ) {
    this.store.select(getSideMenuStatus).subscribe(sideMenu => {
      // updare sidebar css variable to match the modal backdrop and position
      if (sideMenu) {
        document.documentElement.style.setProperty('--sidebar-width', '20px');
      } else {
        document.documentElement.style.setProperty('--sidebar-width', '300px');
      }
    });
  }

  ngOnInit() {
  }
  buyAssets() {
    this.modal.dismiss(
      { action: 'buy-assets' }
    );
  }

  closeModal() {
    this.modal.dismiss();
  }

}
